export default {"src":"/_next/static/media/initDownload.84962025.svg","height":88,"width":236};